import { render, staticRenderFns } from "./ProductItemShow.vue?vue&type=template&id=ff216cc4&scoped=true&"
import script from "./ProductItemShow.vue?vue&type=script&lang=js&"
export * from "./ProductItemShow.vue?vue&type=script&lang=js&"
import style0 from "./ProductItemShow.vue?vue&type=style&index=0&id=ff216cc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff216cc4",
  null
  
)

export default component.exports